(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acsell-card-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('acsell-card-carousel')) return;

    class AcsellCardCarousel extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.viewport = this.querySelector('[data-cc-viewport]');
        this.track = this.querySelector('[data-cc-track]');
        this.real = Array.from(this.track.querySelectorAll(':scope > [data-cc-item]'));
        this.n = this.real.length;
        if (this.n < 2) return;

        this.interval = Math.max(1500, parseInt(this.dataset.interval, 10) || 3000);
        this.userPaused = this.dataset.autoplay === 'false';
        this.hover = false;

        // 좌우 복제: 넓은 화면에서도 양옆이 비지 않게 한쪽에 최소 8장
        this.k = Math.max(1, Math.ceil(8 / this.n));
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (let s = 0; s < this.k; s++) {
          for (const el of this.real) before.appendChild(this.clone(el));
          for (const el of this.real) after.appendChild(this.clone(el));
        }
        this.track.insertBefore(before, this.track.firstChild);
        this.track.appendChild(after);
        this.items = Array.from(this.track.children);
        this.pos = this.k * this.n; // 첫 실제 카드

        this.current = this.querySelector('[data-cc-current]');
        this.toggleBtn = this.querySelector('[data-cc-toggle]');
        this.querySelector('[data-cc-prev]')?.addEventListener('click', () => { this.go(this.pos - 1); this.restart(); });
        this.querySelector('[data-cc-next]')?.addEventListener('click', () => { this.go(this.pos + 1); this.restart(); });
        this.toggleBtn?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.syncPause(); this.restart(); });

        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { this.hover = true; this.restart(); } });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { this.hover = false; this.restart(); } });
        this._vis = () => this.restart();
        document.addEventListener('visibilitychange', this._vis);

        this.track.addEventListener('transitionend', (e) => { if (e.target === this.track) this.normalize(); });
        this.bindDrag();
        this._ro = new ResizeObserver(() => this.place(false));
        this._ro.observe(this.viewport);

        this.classList.add('is-ready');
        this.place(false);
        this.syncPause();
        this.restart();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this._vis);
        this._ro?.disconnect();
      }

      clone(el) {
        const c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('a,button').forEach((a) => a.setAttribute('tabindex', '-1'));
        return c;
      }

      offsetFor(pos) {
        const it = this.items[pos];
        return this.viewport.clientWidth / 2 - (it.offsetLeft + it.offsetWidth / 2);
      }

      place(animate, extra = 0) {
        if (!this.items) return;
        this.track.classList.toggle('no-anim', !animate);
        this.track.style.transform = `translate3d(${this.offsetFor(this.pos) + extra}px,0,0)`;
        this.items.forEach((it, i) => {
          it.classList.toggle('is-active', i === this.pos);
          it.classList.toggle('is-before', i < this.pos);
          it.classList.toggle('is-after', i > this.pos);
        });
        const real = ((this.pos - this.k * this.n) % this.n + this.n) % this.n;
        if (this.current) this.current.textContent = String(real + 1);
        this.real.forEach((it, i) => it.setAttribute('aria-current', i === real ? 'true' : 'false'));
      }

      // 복제 구간에 있으면 같은 카드의 실제 위치로 순간이동(애니메이션 없이)
      normalize() {
        const lo = this.k * this.n, hi = lo + this.n;
        if (this.pos >= lo && this.pos < hi) return;
        this.pos = lo + (((this.pos - lo) % this.n) + this.n) % this.n;
        this.place(false);
        void this.track.offsetWidth; // 리플로우 강제 → 다음 이동은 다시 애니메이션
      }

      go(target) {
        const delta = target - this.pos;
        this.normalize();
        this.pos = Math.max(0, Math.min(this.items.length - 1, this.pos + delta));
        this.place(true);
      }

      syncPause() {
        this.classList.toggle('is-paused', this.userPaused);
        if (this.toggleBtn) {
          this.toggleBtn.setAttribute('aria-pressed', String(this.userPaused));
          this.toggleBtn.setAttribute('aria-label', this.userPaused ? 'Play autoplay' : 'Pause autoplay');
        }
      }

      restart() {
        clearTimeout(this.timer);
        if (this.userPaused || this.hover || this.dragging || document.hidden) return;
        this.timer = setTimeout(() => { this.go(this.pos + 1); this.restart(); }, this.interval);
      }

      bindDrag() {
        const vp = this.viewport;
        let startX = 0, startY = 0, dx = 0, id = null, moved = false, locked = null;
        vp.addEventListener('dragstart', (e) => e.preventDefault());
        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          id = e.pointerId; startX = e.clientX; startY = e.clientY; dx = 0; moved = false; locked = null;
          this.normalize();
        });
        vp.addEventListener('pointermove', (e) => {
          if (e.pointerId !== id) return;
          const mx = e.clientX - startX, my = e.clientY - startY;
          if (locked === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) {
            locked = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
            if (locked === 'x') {
              this.dragging = true; moved = true;
              vp.classList.add('is-dragging');
              try { vp.setPointerCapture(id); } catch (_) {}
              clearTimeout(this.timer);
            }
          }
          if (locked !== 'x') return;
          dx = mx;
          this.place(false, dx);
        });
        const end = (e) => {
          if (e.pointerId !== id) return;
          id = null;
          vp.classList.remove('is-dragging');
          if (locked === 'x') {
            const step = (this.items[1]?.offsetLeft ?? 0) - (this.items[0]?.offsetLeft ?? 0) || 300;
            let n = Math.round(-dx / step);
            if (n === 0 && Math.abs(dx) > 40) n = dx < 0 ? 1 : -1;
            this.dragging = false;
            this.pos = Math.max(0, Math.min(this.items.length - 1, this.pos + n));
            void this.track.offsetWidth;
            this.place(true);
          }
          this.dragging = false;
          locked = null;
          this.restart();
        };
        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);
        // 드래그 뒤 링크 클릭 막기
        vp.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      }
    }

    customElements.define('acsell-card-carousel', AcsellCardCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
